export default __webpack_public_path__ + "static/media/techcrunch.6d0f436b.png";